import { EventEmitter, Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { CatalogSearchResultDisplayType } from "@enums/catalog-search-result-display-type";
import { CatalogItemSearchResultDto, SearchFilterEntryDto, SearchFilterId } from "@interfaces/HttpClient/SearchApiModels";
import { ICatalogRoutingParams } from "@interfaces/iCatalogRoutingParams";
import { TagModel } from "@interfaces/iTagFilter";
import { SearchService } from "./search.service";
import { SearchbarService } from "./searchbar.service";



@Injectable()
export class SearchResultService {
	private static catalogSearchChanged = new EventEmitter<CatalogSearchresultModel>();
	private static catalogSearchTrigger = new EventEmitter<boolean>();
	private static catalogTriggerSearchNoResultTrigger = new EventEmitter<{ searchResult: CatalogItemSearchResultDto, searchTerm: string; refresh: boolean; catalogKey?: string }>();

	public get catalogSearchChanged() {
		return SearchResultService.catalogSearchChanged;
	}

	public get catalogSearchTrigger() {
		return SearchResultService.catalogSearchTrigger;
	}

	public get catalogTriggerSearchNoResultTrigger() {
		return SearchResultService.catalogTriggerSearchNoResultTrigger;
	}

	private static isSearching = false;

	constructor(private searchbarService: SearchbarService) { }

	public createSearchFilter(selectedTags: TagModel[], tags?: TagModel[]): string {
		const filterStrings = [];
		const selected = tags ?? selectedTags;
		if (selected.length > 0) {
			// Inkrementeller Filter: Das + hinter der ID bedeutet, dass die momentane Filterauswahl die gelieferten Filterwerte beeinflusst. Das ist genauso vom PO gewünscht und soll so sein!
			let tagFilter = SearchFilterId.Tag + "+:";
			tagFilter += selected
				.map(st => st.id)
				.join("|");
			filterStrings.push(tagFilter);
		}
		const filter = filterStrings.join(",");
		return filter === "" ? undefined : filter;
	}

	public isSearching() {
		return SearchResultService.isSearching;
	}

	// Wegen zyklischer Abhängigkeit searchservice direkt übergeben
	public async navigate(searchService: SearchService, router: Router, displayType: CatalogSearchResultDisplayType, currentRoutingParams: ICatalogRoutingParams, selectedTags: TagModel[], clearFilter?: boolean, tags?: TagModel[]) {
		searchService.refresh();
		const searchFilter = clearFilter ? undefined : this.createSearchFilter(selectedTags, tags);
		if (!searchFilter && !this.searchbarService.searchTerm) {
			let route = ['/catalog', currentRoutingParams.key];
			if (currentRoutingParams.catalogItemGuid) {
				route = route.concat(['catalogItem', currentRoutingParams.catalogItemGuid]);
			}
			if (currentRoutingParams.attachmentId) {
				route = route.concat(['attachment', currentRoutingParams.attachmentId]);
			}
			await router.navigate(route, { queryParams: { searchTerm: undefined, searchFilter: undefined, searchResultDisplayType: undefined, searchPage: undefined }, queryParamsHandling: 'merge' });

		} else {
			SearchResultService.isSearching = true;
			await searchService.navigateToCatalog({
				catalogKey: currentRoutingParams.key,
				searchTerm: this.searchbarService.searchTerm,
				searchFilter,
				pageIndex: 0,
				pageSize: 30
			}, displayType);
			SearchResultService.isSearching = false;
		}
	}
}

export interface CatalogSearchresultModel {
	searchTags: TagModel[];
	isEmptySearch: boolean;
	catalogFilterEntries: SearchFilterEntryDto[];
	displayType: CatalogSearchResultDisplayType;
	indexDirty?: boolean
}
